import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getOnboardingOrderCount = {
  name: "getOnboardingOrderCount" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    ordersLast90Days: z.number(),
    projectedAnnualOrders: z.number(),
    returnRate: z.number(),
    fetchedAt: z.date(),
    unavailable: z.boolean(),
  }),
};
